import { useEffect, useRef, useState } from "react";
import { getConfig, searchAPI } from "../apis";
import { useDispatch } from "react-redux";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { setsearch } from "../redux/features/dataSlice";
import { useSelector } from "react-redux";
import { dataCount } from "../pages/NewsCategoryPage";
import { axiosInstance } from "../functions/axios";
import { subtractYearsAndGetFormattedDate } from "../functions/time";

export default function useInfiniteScrollCategory(
  offset,
  setloading,
  academiaSearch,
  category,
  setcategory,
  setoffset,
  setShouldLoad
) {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { query, category: categoryUrl } = useParams();
  const location = useLocation();

  const initialRenderRef = useRef(true);

  const [scrollLoading, setscrollLoading] = useState(true);
  const [range, setRange] = useState(null);
  const [error, setError] = useState(false);
  const [hasMore, setHasMore] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const { fromDate, toDate, academiaSearchList } = useSelector(
    (state) => state.data
  );

  const date = new Date();
  const currentDate = `${date.getFullYear()}-${(
    "0" +
    (date.getMonth() + 1)
  ).slice(-2)}-${("0" + date.getDate()).slice(-2)}`;
  const formatCustomDate = () => {
    if (!fromDate || !toDate) return "";
    return `${fromDate.getFullYear()}-${("0" + (fromDate.getMonth() + 1)).slice(
      -2
    )}-${("0" + fromDate.getDate()).slice(-2)}..${toDate.getFullYear()}-${(
      "0" +
      (toDate.getMonth() + 1)
    ).slice(-2)}-${("0" + toDate.getDate()).slice(-2)}`;
  };
  const customDate = `${formatCustomDate()}`;

  const currentDateMinusOne = subtractYearsAndGetFormattedDate(date, 1);
  const currentDateMinusTwo = subtractYearsAndGetFormattedDate(date, 2);
  const currentDateMinusThree = subtractYearsAndGetFormattedDate(date, 3);

  const filterValue = {
    "Past 24 hours": "Day",
    "Past Week": "Week",
    "Past Month": "Month",
    "Past Year": `${currentDateMinusOne}..${currentDate}`,
    "Past 2 Years": `${currentDateMinusTwo}..${currentDate}`,
    "Past 3 years": `${currentDateMinusThree}..${currentDate}`,
    "All time": "",
    "Custom Date": `${customDate}`,
  };
  const filterTerm = searchParams.get("filter");

  async function getData() {
    setscrollLoading(true);
    setloading(true);
    try {
      const localData = JSON.parse(localStorage.getItem("category"));

      if (localData) {
        setcategory(localData);
        setHasMore(localData);
        setscrollLoading(false);
        setloading(false);
        localStorage.removeItem("category");
      } else {
        // setcategory({});
        setoffset(0);

        let apiConfig = {
          method: "POST",
          url: searchAPI.search,
          data: {
            SearchTerm: query,
            Media: categoryUrl,
            timePeriod: filterValue[filterTerm],
            Count: `21`,
            Offset: `0`,
          },
          ...getConfig(),
        };

        if (
          academiaSearch !== "Academia" &&
          location.pathname.toLocaleLowerCase().startsWith("/category/academia")
        ) {
          apiConfig.url = searchAPI.academiaSearch;
          apiConfig.data = {
            query: query,
            offset: `${offset}`,
            limit: `10`,
            userId: user.userId,
            academiaId: academiaSearchList.filter(
              (academia) => academia.categoryName_chr === academiaSearch
            )[0].academiaId_ids,
          };
        }

        const res = await axiosInstance(apiConfig);

        let newData;
        if (
          academiaSearch !== "Academia" &&
          location.pathname.toLocaleLowerCase().startsWith("/category/academia")
        ) {
          newData = res.data.data.results ? res.data.data.results : [];
        } else {
          newData = res.data.data.webPages ? res.data.data.webPages.value : [];
        }
        setcategory(newData);
        setHasMore(!!newData.length);
        setscrollLoading(false);
        setloading(false);
        setShouldLoad(false);
      }
    } catch (error) {
      console.log(error);

      setloading(false);
    }
  }

  useEffect(() => {
    dispatch(setsearch(query));
    if (query.length && academiaSearch.length && academiaSearchList.length) {
      getData();
    }
  }, [query, filterTerm, academiaSearch, academiaSearchList]);

  useEffect(() => {
    async function getData() {
      try {
        setscrollLoading(true);
        setloading(true);
        setError(false);
        let cancel;

        // Default configuration
        let apiConfig = {
          method: "POST",
          url: searchAPI.search,
          data: {
            SearchTerm: query,
            Media: categoryUrl,
            timePeriod: filterValue[filterTerm],
            Count: `21`,
            Offset: `${offset}`,
          },
          ...getConfig(),
          cancelToken: new axiosInstance.CancelToken((c) => (cancel = c)),
        };
        // Modify the configuration based on academiaSearch value
        if (
          academiaSearch !== "Academia" &&
          location.pathname.toLocaleLowerCase().startsWith("/category/academia")
        ) {
          apiConfig.url = searchAPI.academiaSearch;
          apiConfig.data = {
            query: query,
            offset: `${offset}`,
            limit: `10`,
            userId: user.userId,
            academiaId: academiaSearchList.filter(
              (academia) => academia.categoryName_chr === academiaSearch
            )[0].academiaId_ids,
          };
          apiConfig.cancelToken = new axiosInstance.CancelToken(
            (c) => (cancel = c)
          );
        }

        const res = await axiosInstance(apiConfig);

        // Process the response data based on academiaSearch value
        let newData;
        if (
          academiaSearch !== "Academia" &&
          location.pathname.toLocaleLowerCase().startsWith("/category/academia")
        ) {
          newData = res.data.data.results ? res.data.data.results : [];
        } else {
          newData = res.data.data.webPages ? res.data.data.webPages.value : [];
        }

        setcategory((prevProps) => [...prevProps, ...newData]);
        setHasMore(!!newData.length); // Assuming you want to check if data exists
        setscrollLoading(false);
        setShouldLoad(false);
      } catch (error) {
        console.log(error);
        if (axiosInstance.isCancel()) return;
        setError(true);
        if (academiaSearch === "semantics" || academiaSearch === "core") {
          setHasMore(false);
        }
        setscrollLoading(false);
      }
    }

    if (initialRenderRef.current) {
      initialRenderRef.current = false;
    } else {
      if (offset !== 0) {
        getData();
      }
    }
    setloading(false);
  }, [offset]); // Include academiaSearch in the dependency array

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const newRange = queryParams.get("range");

    if (newRange !== range) {
      setRange(newRange);
      dispatch(setsearch(query));
      getData();
    }
  }, [location.search]);

  return { scrollLoading, error, hasMore };
}
